var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChatLoom = function SvgChatLoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "#1874FD",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ChatLoom_svg__a)",
    fill: "#FDFDFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.948 11.984a1.15 1.15 0 0 1 1.15 1.151v9.209a1.15 1.15 0 0 1-1.15 1.15H15.914c-.61 0-1.196.244-1.628.675l-2.302 2.302V13.135a1.15 1.15 0 0 1 1.151-1.15h13.813Zm-13.813-1.15a2.302 2.302 0 0 0-2.302 2.301v14.726a.574.574 0 0 0 .983.406l3.284-3.284c.216-.216.509-.337.814-.337h11.034a2.302 2.302 0 0 0 2.302-2.302v-9.209a2.302 2.302 0 0 0-2.302-2.302H13.135Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.286 14.862a.576.576 0 0 1 .576-.576h10.36a.576.576 0 0 1 0 1.152h-10.36a.576.576 0 0 1-.576-.576Zm0 2.878a.576.576 0 0 1 .576-.576h10.36a.576.576 0 0 1 0 1.151h-10.36a.576.576 0 0 1-.576-.575Zm0 2.877a.576.576 0 0 1 .576-.575h5.755a.576.576 0 0 1 0 1.15h-5.755a.575.575 0 0 1-.576-.575Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ChatLoom_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10.833 10.833)",
    d: "M0 0h18.417v18.417H0z"
  })))));
};

export default SvgChatLoom;